/**
 * The public site key of the reCAPTCHA enterprise.
 * @type {string}
 */
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

window.recaptchaOptions = {
  enterprise: true,
};
